module.exports = __webpack_public_path__ + "static/img/stephen_chiu.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wmm/stephen_chiu.jpg
// module id = B0lX
// module chunks = 0